// extracted by mini-css-extract-plugin
module.exports = {"pending_transaction":"PendingPaymentCard_pending_transaction__3NaDz"};